import React, { useCallback } from 'react';
import { Button, Modal } from '@cognitiv/cyprus-ui';
import { BatchHistoryTable } from 'components/batch-history/BatchHistoryTable';
import { selectBatches } from 'ducks/batches/selectors';
import { useAppDispatch, useAppSelector } from 'ducks/hooks';
import { selectScheduleBatchHistory } from 'ducks/modals/selectors';
import { setModal } from 'ducks/modals/slices';
import { useSwitchTheme } from 'hooks/useSwitchTheme';
import { shallowEqual } from 'react-redux';

import cn from 'modals/batches/components/Components.module.scss';

export const ScheduleBatchHistory = () => {
  const dispatch = useAppDispatch();
  const { theme } = useSwitchTheme();

  const schedule_batch_history = useAppSelector(selectScheduleBatchHistory, shallowEqual);
  const batches = useAppSelector(selectBatches);

  const closeModal = useCallback(() => {
    dispatch(setModal({ schedule_batch_history: false }));
  }, [dispatch]);

  return (
    <Modal
      name="schedule_batch_history"
      show={schedule_batch_history}
      padding={0}
      width={1250}
      close_box={50}
      onClose={closeModal}
      standard={false}
    >
      <h2 className={cn.header} style={{ borderBottom: theme.border, color: theme.font_color }}>
        Scheduled Batch History
      </h2>
      <div className={cn.content}>
        <BatchHistoryTable rows={batches} />
        <div className={cn.buttonContainer}>
          <div className={cn.flexGrow} />
          <Button width={115} variant="blue" onClick={closeModal}>
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};
